var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_vm._l((_vm.formalization.titleStudies),function(titleStudy){return [_c('div',{class:_vm.b('title')},[_vm._v("Estudio de Título: (#"+_vm._s(titleStudy.id)+")")]),_c('title-study-content-row',{key:titleStudy.id,staticClass:"mb-4",attrs:{"title-study":titleStudy}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }